import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').directive('bindCompiledHtml', bindCompiledHtml);

    /**
     * copy from http://stackoverflow.com/questions/18690804/insert-and-parse-html-into-view-using-angularjs
     *
     * @param $compile
     * @returns {{template: string, scope: {rawHtml: string}, link: Function}}
     */
    function bindCompiledHtml($compile) {
        return {
            template: '<div></div>',
            scope: {
                rawHtml: '=bindCompiledHtml'
            },
            link: function (scope, elem) {
                scope.$watch('rawHtml', function (value) {
                    if (!value) {
                        return;
                    }
                    var newElem = $compile('<p>' + value + '</p>')(
                        scope.$parent
                    );
                    elem.contents().remove();
                    elem.append(newElem);
                });
            }
        };
    }
})();
